import { TweenAnimation } from "./tweenAnimation";
import IsolationSequenceAnimation from "./isolationSequenceAnimation";

function addAnimation() {

    //cleanup
    if (Q3.animations) {
        Q3.animations.forEach((animation) => {
            animation.kill();
        })
    }
    Q3.animations = [];

    Q3.data.slides.forEach((slide, i) => {
        var animationType = Q3.data.slides[i].animationType || "TweenAnimation";//default to support old projects

        switch (animationType) {
            case "TweenAnimation":
                Q3.animations[i] = new TweenAnimation(i);
                break;
            case "IsolationSequence":
                Q3.animations[i] = new IsolationSequenceAnimation(i);
                break;
            default:
                Q3.animations[i] = new TweenAnimation(i);
                break;
        }
    });
}

export default addAnimation;
export { addAnimation };